import { Link, useLocation } from 'react-router-dom';
import { Home, AlertTriangle } from 'lucide-react';
import { Button } from '@nepal-ecom/ui';

export function NotFound() {
  const location = useLocation();
  return (
    <div className="flex flex-col items-center justify-center text-center py-20 animate-fade-in">
      <div className="h-14 w-14 rounded-full bg-amber-50 ring-1 ring-amber-100 flex items-center justify-center mb-4">
        <AlertTriangle className="h-7 w-7 text-amber-600" />
      </div>
      <h1 className="text-2xl font-bold text-slate-900">Page not found</h1>
      <p className="text-sm text-slate-500 mt-2 max-w-md">
        <code className="px-1.5 py-0.5 rounded bg-slate-100 text-slate-700 text-xs">{location.pathname}</code>{' '}
        does not match any admin route.
      </p>
      <Button asChild className="mt-5" size="sm">
        <Link to="/"><Home className="h-4 w-4" /> Back to dashboard</Link>
      </Button>
    </div>
  );
}
